<template>
  <div class="wrapper">
    <loader v-show="loading" style="z-index: 999999 !important;"></loader>
    <transition name="modal">
      <Modal v-if="open_modal" v-on:close="close_modal">
        <div slot="header">
          <h5 class="font-bold" v-html="modal_info.title"></h5>
        </div> 
        <div slot="body" v-html="modal_info.body">
          
        </div>
        <div slot="footer" class="text-right" v-if="modal_info.has_btns">
          <button type="button" class="btn bg-green-light ml-1 mr-1" v-on:click="set_save(true)">
            <span v-if="modal_info.btn_text">{{modal_info.btn_text}}</span>
            <span v-else>{{trans['CONFIRMAR']}}</span>
          </button>
          <button type="button" class="btn btn-danger ml-1 mr-1" data-dismiss="modal" v-on:click="set_save(false)">{{trans['CANCELAR']}}</button>
        </div>
      </Modal>
    </transition>

     <b-navbar class="bg-white border-bottom" toggleable="sm" type="light" sticky v-if="is_logged">
       <b-navbar-nav>
        <b-nav-item v-if="$route.name == 'room_consumes'" v-on:click="showNotice">
          <span class="color-green fa fa-arrow-left"></span>
        </b-nav-item>
        <b-nav-item v-else-if="$route.name == 'room_clothes' || $route.name == 'room_inspection'" v-on:click="set_save(true)">
          <span class="color-green fa fa-arrow-left"></span>
        </b-nav-item>
        <b-nav-item v-else-if="back_link !== null" v-on:click="go_to(back_link)" >
          <span class="color-green fa fa-arrow-left"></span>
        </b-nav-item>
      </b-navbar-nav>

      <b-navbar-brand href="#"></b-navbar-brand>

      <b-navbar-nav class="mr-auto">
        <b-nav-item v-if="modal_info !== null && $route.name == 'list_rooms'" v-on:click="open_modal = true">
          <span class="color-green fa fa-comment"></span>
          {{trans['OBSERVACOES']}}
        </b-nav-item>
      </b-navbar-nav>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav ref="navCollapse"  v-model="isNavCollapsed">
        <b-navbar-nav>
          <b-nav-item v-if="$distribution.zones && $route.name == 'list_rooms'" @click="go_to({name: 'zone_clothes', params: {lang: $route.params.lang, cod_dist_zone: $route.params.cod_dist_zone, search_hotel: $distribution.search_hotel, search_bloco: $distribution.search_bloco, search_piso: $distribution.search_piso, search_n_quarto: $distribution.search_n_quarto}})">
            <span class="color-green fa fa-tshirt"></span>
            {{trans['ROUPA']}}
          </b-nav-item>

          <b-nav-item v-if="$distribution.zones && ( $route.name == 'list_rooms' || $route.name == 'list_zones' )" @click="go_to({name: 'zone_rooms', params: {lang: $route.params.lang, cod_dist_zone: $route.params.cod_dist_zone,search_hotel: $distribution.search_hotel, search_bloco: $distribution.search_bloco, search_piso: $distribution.search_piso, search_n_quarto: $distribution.search_n_quarto}})">
            <span class="color-green fa fa-bed"></span>
            {{trans['RESUMO']}}
          </b-nav-item>

          <b-nav-item v-if="$route.name == 'list_zones'" v-on:click="go_to({name: 'zone_no_show', params: {lang: $route.params.lang, cod_hotel: $distribution.cod_hotel, search_hotel: $distribution.search_hotel, search_bloco: $distribution.search_bloco, search_piso: $distribution.search_piso, search_n_quarto: $distribution.search_n_quarto}})">
            <span class="color-green fa fa-user-times"></span>
              {{trans['NO_SHOW']}}
          </b-nav-item>

          <b-nav-item class="d-none" v-on:click="send_sos">
            <span class="color-green fa fa-concierge-bell"></span>
          </b-nav-item>

          <b-nav-item v-if="$route.name == 'list_rooms' || $route.name == 'list_zones' || $route.name == 'no_distribution'" @click="search_pesquisa(true)">
            <span class="color-green fa fa-sync"></span>
            {{trans['ATUALIZAR']}}
          </b-nav-item>

          <b-nav-item v-if="$route.name == 'list_zones' || $route.name == 'no_distribution'" @click="search_modal(true)">
            <span class="color-green fa fa-search"></span>
            {{trans['PESQUISAR']}}
          </b-nav-item>

          <div v-if="$route.name == 'list_zones' || $route.name == 'no_distribution'" style="display: flex; align-items: center;">
            <span class="color-green fa fa-hotel"></span>
            <b-form-select v-model="search_hotel" :options="list_hotel" style="width: auto; margin-left: 5px ; padding: 0 1.75rem 0 0.75rem; height: 28px;"></b-form-select>
          </div>

          <b-navbar-brand id="title-h4" v-if="$route.meta.title">
            <span class="color-green font-weight-bold text-truncate">{{$route.meta.title}}</span>
          </b-navbar-brand>
          <b-tooltip target="title-h4" triggers="hover">
            {{$route.meta.title}}
          </b-tooltip>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto" v-if="$route.name != 'login'" >
          <b-nav-item v-on:click="logout()" >
            <span class="color-green fa fa-sign-out-alt"></span>
            {{trans['SAIR']}}
          </b-nav-item>
          <b-nav-text style="width: 175px">{{$distribution.dist_date_pt}} {{time}}</b-nav-text>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <b-modal ref="search_modal" :title="'Pesquisar'" v-model="search_modal_open">
      <b-container fluid>
        {{trans['BLOCO']}}
        <b-form-select v-model="search_bloco" :options="list_bloco">
          <template #first>
            <b-form-select-option :value="null">---</b-form-select-option>
          </template>
        </b-form-select>
        <br><br>
        {{trans['PISO']}}
        <b-form-select v-model="search_piso" :options="list_piso">
          <template #first>
            <b-form-select-option :value="null">---</b-form-select-option>
          </template>
        </b-form-select>
        <br><br>
        {{trans['N_QUARTO']}}        
        <b-form-input v-model="search_n_quarto" type='number'></b-form-input>
      </b-container>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button
            variant="outline-success"
            class="float-right"
            @click="search_pesquisa(false)"
          >            
            {{trans['PESQUISAR']}}
          </b-button>
          <b-button
            variant="outline-danger"
            class="float-right mr-3"
            @click="clearSearchFields(true)"
          >
            {{trans['RESET']}}            
          </b-button>
          <b-button
            variant="outline-secondary"
            class="float-right mr-3"
            @click="search_modal(false)"
          >
            {{trans['FECHAR']}} 
          </b-button>
        </div>
      </template>
    </b-modal>

    <router-view
      v-on:logout="is_logged = false"
      v-on:set_modal_info="set_modal_info"
      v-on:set_back_link="set_back_link"
      v-on:set_room_to_save="set_room_to_save"
      v-on:show_consumes_alert="showConsumesAlert = true"
      v-on:show_notice="showNotice"
      v-on:login="login_process"
      v-on:go_to="go_to"
      v-on:set_loading="set_loading"
      v-on:refresh_rooms="refresh_rooms"
      :key="$route.fullPath+ '_' +times_updated" 
      ref="comp">
    </router-view>
  </div>
</template>
<script>

import Modal from '@/components/Modal.vue';

export default {
  data() {
    return {
      time: '',
      req_timer: null,
      loading: false,
      back_link: null,
      prev_modal_info: null,
      modal_info: null,
      open_modal: false,
      showConsumesAlert: false,
      times_updated: 0, // to update the child component, :key attribute on router-view when refresh_rooms()
      refreshing: false,
      // data: 
      is_logged: localStorage.getItem('is_logged') !== null,
      search_modal_open: null,
      open_modal_not_trigger: false,
      list_hotel: [],
      list_bloco: [],
      list_piso: [],
      search_hotel: null,
      search_bloco: null,
      search_piso: null,
      search_n_quarto: null,
      isNavCollapsed: false,
      clearFields: false,
    }
  },
  components: {
    Modal
  },
  methods: {
    logout : function (){
      localStorage.removeItem('user_lang');
      localStorage.removeItem('is_logged');
      localStorage.removeItem('code');
      this.$emit('logout');
      this.$router.push({name: 'login', params: {lang: this.$route.params.lang}});
    },
    go_to: function (routeParams) {
      this.set_loading(true);
      setTimeout(() => this.$router.push(routeParams), 50);
    },
    set_loading: function (status) {
      this.loading = status;
    },
    login_process: function() {
      this.is_logged = true;
    },
    get_time: function() {
      let d = new Date();
      this.time = String(d.getHours()).padStart(2, '0') + ":" + String(d.getMinutes()).padStart(2, '0') + ":" + String(d.getSeconds()).padStart(2, '0');
      setTimeout(this.get_time, 1000);
    },
    set_modal_info: function(val) {
      this.modal_info = val;
    },
    set_room_to_save: function(room) {
      for(var z of this.$distribution.zones) {
        var r_idx = z.rooms.findIndex((item, idx) => item.cod_distribution_room == room.cod_distribution_room);
        if(r_idx !== -1) {
          room.saved = 0;
          this.$set(z.rooms, r_idx, room);
        }
      }
    },
    close_modal: function() {
      if(this.prev_modal_info !== null) {
        this.set_modal_info(this.prev_modal_info);
      }
      this.prev_modal_info = null;
      this.open_modal = false;
    },
    send_sos: function() {
      this.prev_modal_info = this.modal_info;
      this.$http.get('housekeeping/send_sos?token=' +this.$distribution.person.token,
        {
          before(request) {
            this.set_loading(true);
          }
      })
      .then(resp => {
          this.set_modal_info({title: this.trans['AVISO'], body: resp.body.message});
      }, resp => {
          this.set_modal_info({title: '<span class="text-danger">'+this.trans['ERRO']+'</span>', body: this.trans['OCORREU_UM_PROBLEMA_AO_TENTAR']});
      }).then(resp => {
          this.set_loading(false);
          this.open_modal = true;
      });
    },
    set_back_link: function(to) {
      this.back_link = to;
    },
    showNotice: function() {
      if(this.showConsumesAlert) {
        this.open_modal = true;
        this.showConsumesAlert = false;
      }
      else {
        this.set_save(true);
      }
    },
    set_save: function(bool) {
      this.$refs.comp.save(bool);
      this.open_modal = false;
    },
    refresh_rooms: function(loading, callback = null) {
      var that = this;
      let is_logged = localStorage.getItem('is_logged');
 
      if(!is_logged){
        this.$router.push({name: 'login', params: {lang: this.$route.params.lang, session_expired : true}});
        return;
      }

      if(this.refreshing) {
        return;
      }

      let login_tmp = this.$distribution.person.login_time;

      this.refreshing = true;

      this.$http.post('housekeeping/refresh_data?token=' +this.$distribution.person.token,
        {
          date: this.$distribution.dist_date
        },
        {
          before(request) {
            if(loading) {
              window.scroll(0, 0);
              document.body.style.overflow = 'hidden';
            }
            this.set_loading(loading);
          }
      })
      .then(resp => {
        this.$distribution = resp.body.data;
        this.$distribution.person.login_time = login_tmp;

        localStorage.setItem('extra_beds', JSON.stringify(resp.body.extra_beds));

        this.times_updated += 1;

        if (callback && typeof callback === 'function') {
          callback();
        }
      }, resp => {

      }).then(resp => {
        this.set_loading(false);
        document.body.style.overflow = 'visible';
        this.refreshing = false;
      });
    },
    search_modal(show_modal){
      this.resetModal();

      if(show_modal){
        this.$refs['search_modal'].show();
      }else{
        this.$refs['search_modal'].hide();
      }
    },
    search_pesquisa(refresh, isPopup = true ){
      
      var cod_pessoa      = this.$distribution.person.cod_pessoa;
      let search_hotel    = this.$distribution.search_hotel ? this.$distribution.search_hotel : this.$distribution.cod_hotel;
      let search_bloco    = this.$distribution.search_bloco ? this.$distribution.search_bloco: null;
      let search_piso     = this.$distribution.search_piso ? this.$distribution.search_piso: null;
      let search_n_quarto = this.$distribution.search_n_quarto ? this.$distribution.search_n_quarto: '';

      if(!refresh){
        search_hotel    = this.search_hotel ? this.search_hotel : this.$distribution.cod_hotel;
        search_bloco    = this.search_bloco ? this.search_bloco : null ;
        search_piso     = this.search_piso ? this.search_piso : null;
        search_n_quarto = this.search_n_quarto ? this.search_n_quarto : null;
      }

      this.$http.get('housekeeping/pesquisa?person='+cod_pessoa+'&hotel_id='+search_hotel+'&cod_block='+search_bloco+'&cod_room_floor='+search_piso+'&n_quarto='+search_n_quarto+'&token=' +this.$distribution.person.token,{
          before(request) {
            if(refresh) {
              window.scroll(0, 0);
              document.body.style.overflow = 'hidden';
            }
            this.set_loading(true);
          }
      })
      .then(resp => {
        let login_tmp = this.$distribution.person.login_time;
        let inspect_tmp = this.$distribution.person.can_inspect;
        let view_tmp = this.$distribution.person.view_all;

        var zones = resp.body.data.zones.filter((zone) => {
            return zone.rooms.length > 0;
        });

        var data = resp.body.data;
        data.zones = zones;
        
        this.$storage.set('data', data);
        localStorage.setItem('extra_beds', JSON.stringify(resp.body.extra_beds));
        this.$distribution = data;
        this.$distribution.search_hotel = this.search_hotel;
        this.$distribution.person.login_time = login_tmp;
        this.$distribution.person.can_inspect = inspect_tmp;
        this.$distribution.person.view_all = view_tmp;

        if( isPopup ){
          this.search_modal(false);
        }
        
        if( this.$route.name == 'list_rooms' ){
          this.$refs.comp.r_cleaning_times();
        }
                
        if( this.$route.name == 'no_distribution' && ( inspect_tmp == 1 || view_tmp == 1 ) ){
            this.$router.push({
							name: 'list_zones',
							params: {
								zones: this.$distribution.zones,
								lang:  this.$distribution.person.language.lang,
                search_hotel: this.$distribution.search_hotel,
                search_bloco: this.$distribution.search_bloco,
                search_piso: this.$distribution.search_piso,
                search_n_quarto: this.$distribution.search_n_quarto
							}
						});
            return;
        } else if( this.$route.name == 'no_distribution' && inspect_tmp == 0 ) {
            this.$router.push({
              name: 'list_rooms',
              params: {
                zones: this.$distribution.zones,
                lang:  this.$distribution.person.language.lang,
                cod_dist_zone: this.$distribution.zones[0].cod_distribution_zone,
                search_hotel: this.$distribution.search_hotel,
                search_bloco: this.$distribution.search_bloco,
                search_piso: this.$distribution.search_piso,
                search_n_quarto: this.$distribution.search_n_quarto
              }
            });
        }
        
      }, resp => {
        if( this.clearFields ){
            this.clearSearchFields();
            this.clearFields = false;
        }

        if( this.$route.name != 'no_distribution' ){
          
          this.$router.push({
            name: 'no_distribution',
            params: {
              lang: this.$distribution.person.language.lang,
              cod_dist_zone: this.$distribution.zones[0].cod_distribution_zone,
              message: resp.body.message,
              search_hotel   : this.search_hotel,
              search_bloco   : this.search_bloco,
              search_piso    : this.search_piso,
              search_n_quarto: this.search_n_quarto
            }            
          });
          return;
        }

        if( this.$route.name == 'no_distribution' ) {
          if( this.$refs['search_modal'] ){
            this.$refs['search_modal'].hide();
          }
        }

      }).then(resp => {
        this.set_loading(false);
        if(refresh) {
          document.body.style.overflow = 'visible';
        }
      });
    },
    resetModal(){
      this.set_loading(true);
      this.open_modal_not_trigger = true;

      this.$http.get('housekeeping/get/blocos?hotel_id='+this.search_hotel+'&token=' +this.$distribution.person.token,{
          before(request) {
            // this.set_loading(true);
          }
      })
      .then(resp => {
        this.list_bloco = resp.body.map(function(item, index){
          item.value = item.cod_block;
          item.text = item.name;
          return item;
        });
        this.list_piso = [];
        if(this.$distribution.search_bloco){
          this.search_bloco = this.$distribution.search_bloco;
        
          this.$http.get('housekeeping/get/pisos?cod_block='+this.search_bloco+'&token=' +this.$distribution.person.token,{
              before(request) {
                // this.set_loading(true);
              }
          })
          .then(resp => {
            this.list_piso = resp.body.map(function(item, index){
              item.value = item.cod_room_floor;
              item.text = item.floor_name;
              return item;
            });
            if(this.$distribution.search_piso){
              this.search_piso = this.$distribution.search_piso;
            }else{
              this.search_piso = null;
            }
          }, resp => {
            this.$bvToast.toast('Ocorreu um problema ao obter a lista de pisos.', {
              title: 'Erro',
              variant: 'danger',
              solid: true
            });
          }).then(resp => {
            this.set_loading(false);
            this.open_modal_not_trigger = false;
          });

        }else{
          this.search_bloco = null;
          this.open_modal_not_trigger = false;
          this.set_loading(false);
        }

      }, resp => {
        this.$bvToast.toast('Ocorreu um problema ao obter a lista de blocos.', {
          title: 'Erro',
          variant: 'danger',
          solid: true
        });
        this.open_modal_not_trigger = false;
        this.set_loading(false);
      }).then(resp => {
          // this.set_loading(false);
      });

    },
    clearSearchFields( isResetBTN = false ){
        this.search_bloco = null;
        this.search_piso = null;
        this.search_n_quarto = '';

        this.$distribution.search_bloco = null;
        this.$distribution.search_piso = null;
        this.$distribution.search_n_quarto = '';

        if( isResetBTN ){
          this.search_pesquisa(false);
        }
    }
  },
  computed: {
    save_items: function() {
      let rooms_changed = [];
      if(this.$distribution !== null && typeof this.$distribution.zones !== 'undefined') {
        for(let z of this.$distribution.zones) {
          rooms_changed = rooms_changed.concat(z.rooms.filter((item, idx) => item.saved == 0));
        }
      }
      return rooms_changed;
    },
    login_time: function() {
      return Math.round(+new Date()/1000)-this.$distribution.person.login_time;
    }
  },
  watch: {
    save_items: {
      handler: function(new_val, old_val) {        
        this.$refs.comp.send_data(new_val);
      },
      deep: true
    },
    search_modal_open: function(new_val, old_val) {
      // if(!new_val){
      //   if(this.$distribution.search_hotel){
      //     this.search_hotel = this.$distribution.search_hotel;
      //   }
      //   if(this.$distribution.search_bloco){
      //     this.search_bloco = this.$distribution.search_bloco;
      //   }
      //   if(this.$distribution.search_piso){
      //     this.search_piso = this.$distribution.search_piso;
      //   }
      //   if(this.$distribution.search_n_quarto){
      //     this.search_n_quarto = this.$distribution.search_n_quarto;
      //   }
      // }
    },
    search_hotel: function(new_val, old_val) {
      if( new_val != old_val && old_val != null ){
        this.clearSearchFields();
        this.search_hotel = new_val;
        this.$distribution.search_hotel = new_val;
        this.$distribution.cod_hotel = new_val;
        this.clearFields = true;
      }
      
      if(new_val && !this.open_modal_not_trigger){
        
        var collapse = this.$refs.navCollapse;
        if (collapse && typeof collapse.toggle === 'function' && this.isNavCollapsed) {
          collapse.toggle();
        }

        this.$http.get('housekeeping/get/blocos?hotel_id='+new_val+'&token=' +this.$distribution.person.token,{
            before(request) {
              this.set_loading(true);
            }
        })
        .then(resp => {
          this.list_bloco = resp.body.map(function(item, index){
            item.value = item.cod_block;
            item.text = item.description;
            return item;
          });
          this.list_piso = [];
          this.search_bloco = null;
          this.search_piso = null;
        }, resp => {
          this.$bvToast.toast('Ocorreu um problema ao obter a lista de blocos.', {
            title: 'Erro',
            variant: 'danger',
            solid: true
          });
        }).then(resp => {
            this.set_loading(false);
            
            if( old_val ){
              this.search_pesquisa(false, false);
            }

        });

      }

    },
    search_bloco: function(new_val, old_val) {
      if(!this.open_modal_not_trigger){
        if(new_val){
          this.$http.get('housekeeping/get/pisos?cod_block='+new_val+'&token=' +this.$distribution.person.token,{
              before(request) {
                this.set_loading(true);
              }
          })
          .then(resp => {
            this.list_piso = resp.body.map(function(item, index){
              item.value = item.cod_room_floor;
              item.text = item.floor_name;
              return item;
            });
            this.search_piso = null;
          }, resp => {
            this.$bvToast.toast('Ocorreu um problema ao obter a lista de pisos.', {
              title: 'Erro',
              variant: 'danger',
              solid: true
            });
          }).then(resp => {
              this.set_loading(false);
          });
        }else{
          this.search_piso = null;
        }
      }
    },
  },
  mounted: function() {
    /*if(this.is_logged)
      this.refresh_rooms(false);*/
  },
  created: function() {
    if(this.is_logged && this.login_time > 14400) { //login time max 4h
      this.$router.push({name: 'login', params: {lang: this.$route.params.lang, session_expired : true}});
      return;
    }
    this.get_time();

    this.list_hotel = JSON.parse(localStorage.getItem('hotels'));

    if(this.$distribution && !this.search_hotel){
      this.$distribution.search_hotel    =  this.$route.params.search_hotel ? this.$route.params.search_hotel : this.$distribution.cod_hotel;  
      this.$distribution.search_bloco    =  this.$route.params.search_bloco ? this.$route.params.search_bloco : null;
      this.$distribution.search_piso     =  this.$route.params.search_piso ? this.$route.params.search_piso : null;
      this.$distribution.search_n_quarto =  this.$route.params.search_n_quarto ? this.$route.params.search_n_quarto : null;
      
      this.search_hotel    =  this.$route.params.search_hotel ? this.$route.params.search_hotel : this.$distribution.cod_hotel;
      this.search_bloco    =  this.$route.params.search_bloco ? this.$route.params.search_bloco : null;
      this.search_piso     =  this.$route.params.search_piso ? this.$route.params.search_piso : null;
      this.search_n_quarto =  this.$route.params.search_n_quarto ? this.$route.params.search_n_quarto : null;

      if( !this.search_hotel ){ // fallback caso não exista nenhum valor introduzido no search_hotel
        this.search_hotel = localStorage.getItem('current_hotel');
        this.$distribution.search_hotel = localStorage.getItem('current_hotel');
        this.$distribution.cod_hotel = localStorage.getItem('current_hotel');
      }
    }

    var that = this;
    window.ononline = function() {
        that.$refs.comp.send_data(that.save_items);
    }
    window.onoffline = function() {
        // alert('You are now offline');
    }
  }
}

</script>
<style>
  .modal-title{
    padding: 10px;
  }
  button.close{
    margin: 0 !important;
  }
</style>
